class Footer {
  constructor () {
    this.init()
  }

  init () {
    const body = document.querySelector('body')
    const ctaWhatsapp = document.querySelector('.c-ctaWhatsapp')
    const ctaWhatsappButton = document.querySelector('.c-ctaWhatsapp__number')
    const ctaContactFormNumber = document.querySelector('.c-contactForm__number')

    function getCookie (name) {
      var dc = document.cookie
      var prefix = name + '='
      var begin = dc.indexOf('; ' + prefix)
      if (begin === -1) {
        begin = dc.indexOf(prefix)
        if (begin !== 0) return null
      } else {
        begin += 2
        var end = document.cookie.indexOf(';', begin)
        if (end === -1) {
          end = dc.length
        }
      }
      return decodeURI(dc.substring(begin + prefix.length, end))
    }

    var gaCookie = getCookie('_ga')

    if (gaCookie != null) {
      if (ctaWhatsappButton) {
        ctaWhatsappButton.addEventListener('click', function () {
          window.dataLayer.push({
            event: 'contact_whatsapp'
          })
        })
      }

      if (ctaContactFormNumber) {
        ctaContactFormNumber.addEventListener('click', function () {
          window.dataLayer.push({
            event: 'cta_phone'
          })
        })
      }
    }

    if (ctaWhatsapp !== null) {
      body.classList.add('hasWhatsapp')
    }
  }
}

export default Footer
